import React from 'react';

import { bemHelper } from '../../helpers';
import getGlobalProps from '../../helpers/constants/global-props';

export interface FadeProps {
  /** Anything inside the fade */
  children: any;
  /** Slate background */
  isInverse?: boolean;
  /** Vertical version */
  isVertical?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const globalProps = getGlobalProps({ inkSass: true });

/**
 * @purpose Adds a fade-to-transparent effect for overflowing content
 */
function Fade(props: FadeProps) {
  const defineClassName = () => {
    const { isVertical, isInverse } = props;
    const b = bemHelper();

    return b('ink-fade', {
      inverse: isInverse,
      vertical: isVertical,
    });
  };

  return (
    <div className={defineClassName()} data-testid={props['data-testid']} {...globalProps}>
      {props.children}
    </div>
  );
}

Fade.defaultProps = {
  isInverse: false,
  isVertical: false,
  'data-testid': undefined,
};

export default Fade;
